import { DocumentFileFormat } from 'routes/document-viewer/-searchParams'

export interface DocumentViewerUrlArgs {
  entryId: string
  /** Actual storage path of the file — the viewer signs { entry_id, path } */
  filePath: string
  title: string
  fileFormat?: DocumentFileFormat
  orgId?: string
  siteId?: string
  pageRotations?: Record<string, number>
  temporaryPreviewUrl?: string
}

/**
 * Build the `/document-viewer` popup URL. The `filename` param must be the
 * real storage path of the file (not the display name) because
 * DocumentViewerPage uses it to request the signed URL.
 */
export const buildDocumentViewerUrl = ({
  entryId,
  filePath,
  title,
  fileFormat,
  orgId,
  siteId,
  pageRotations,
  temporaryPreviewUrl,
}: DocumentViewerUrlArgs): string => {
  const params = new URLSearchParams({
    id: entryId,
    filename: filePath,
    title,
  })
  if (fileFormat) params.set('fileFormat', fileFormat)
  if (orgId) params.set('orgId', orgId)
  if (siteId) params.set('siteId', siteId)
  if (pageRotations && Object.keys(pageRotations).length > 0) {
    params.set('pageRotations', JSON.stringify(pageRotations))
  }
  if (temporaryPreviewUrl)
    params.set('temporaryPreviewUrl', temporaryPreviewUrl)
  return `/document-viewer?${params.toString()}`
}

export const openDocumentViewer = (args: DocumentViewerUrlArgs): void => {
  window.open(buildDocumentViewerUrl(args), '_blank', 'popup=yes')
}
